import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: ${props => props.height || 'auto'};
  overflow: visible;
  padding: ${props => props.padding || '5px 10px'};
  box-sizing: border-box;
`;

@observer
class OnboardingContent extends React.Component {

  render() {
    return (
      <Wrapper
        height={this.props.height}
        padding={this.props.padding}
      >
        {this.props.children}
      </Wrapper>
    );
  }
}

export default OnboardingContent;
